export const cartCostFragment = `
fragment CartCostFragment on CartCost {
  totalAmount { amount }
  subtotalAmount { amount }
  totalTaxAmount { amount }
}
`

export const cartLineFragment = `
fragment CartLineFragment on CartLine {
  id
  attributes {
    key
    value
  }
  merchandise {
    ... on ProductVariant {
      id
      image {
        src
        altText
      }
      price {
        amount
      }
      title
      product {
        id
        title
      }
    }
  }
  quantity
}
`

export const cartDeliveryAddressFragment = `
fragment CartDeliveryAddressFragment on CartDeliveryAddress {
  firstName
  lastName
  company
  address1
  address2
  city
  provinceCode
  zip
  countryCode
  phone
}
`

// Cart fragment (combining both)
export const cartFragment = `
fragment CartFragment on Cart {
  id
  buyerIdentity { email }
  checkoutUrl
  cost {
    ...CartCostFragment
  }
  delivery {
    addresses(selected: true) {
      id
      address {
        ...CartDeliveryAddressFragment
      }
    }
  }
  lines(first: 100) {
    edges {
      node {
        ...CartLineFragment
      }
    }
  }
  note
}
${cartCostFragment}
${cartDeliveryAddressFragment}
${cartLineFragment}
`
